import ApiServer from "../fizapilib.auto.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as Storage from "../../lib/Storage.ts"
import * as Html from "../../util/Html.ts"

const closedById: Record<string, boolean> = JSON.parse(Storage.localGet('categoryState')||"{}")

Html.registerDom({
  tooglecategory(): void {
    const
      metaId = Html.getDomMetaId(this),
      open = closedById[metaId]===false;

    this.parentElement?.classList.toggle('fw-open',open)
    closedById[metaId] = open;
    Storage.localSet('categoryState',JSON.stringify(closedById))
  }
})

Object.assign(ApiServer.types.TaskCategoryBean.prototype,{
  onDecode(): void {
    FwDatas.cache(this);
    if(this.emoji===undefined){
      this.emoji = '🏷️'
    }
    this.isOpen = (): boolean => {
      return closedById[this.metaId]!==false;
    }
  },

})
